import React from 'react';

import styles from './Loader.module.css';

const Loader = ({ darkTheme, extraStyles }) => {
    const spinnerClasses = [styles.spinner];
    if (darkTheme) {
        spinnerClasses.push(styles.dark);
    }

    return (
        <div className={styles.Loader}>
            <div className={spinnerClasses.join(' ')} style={extraStyles}></div>
        </div>
    );
};

export default React.memo(Loader);
